(function () {
  var root = document.getElementById('vetta-flow');
  if (!root) return;

  var steps = Array.prototype.slice.call(root.querySelectorAll('.step'));
  var bars = document.querySelectorAll('#progress i');
  var progress = document.getElementById('progress');
  var current = 0;
  var KEY = 'vetta-join';

  var examples = {
    'Body & bath': 'Everyday body care',
    'Skin & beauty': 'Skin care and clean beauty',
    'Pantry & wellness': 'Nourishing pantry and wellness finds'
  };

  function store(obj) { try { sessionStorage.setItem(KEY, JSON.stringify(obj)); } catch (e) {} }
  function recall() { try { return JSON.parse(sessionStorage.getItem(KEY) || '{}') || {}; } catch (e) { return {}; } }

  function pressed(sel) {
    return Array.prototype.filter.call(root.querySelectorAll(sel), function (b) {
      return b.getAttribute('aria-pressed') === 'true';
    });
  }

  function go(n, opts) {
    opts = opts || {};
    if (n === 2 && !opts.force && pressed('#cats .card').length === 0) {
      document.getElementById('hint1').textContent = 'Pick at least one to continue.';
      return;
    }
    if (n === 4) buildSummary();
    steps[current].hidden = true;
    current = n;
    steps[current].hidden = false;
    if (progress) {
      progress.hidden = current === 0 || current === 5;
      for (var i = 0; i < bars.length; i++) bars[i].classList.toggle('on', i < current);
    }
    window.scrollTo(0, 0);
    var h = steps[current].querySelector('[tabindex="-1"]');
    if (h) h.focus({ preventScroll: true });
  }

  root.querySelectorAll('[data-next]').forEach(function (b) {
    b.addEventListener('click', function () { go(current + 1); });
  });
  root.querySelectorAll('[data-back]').forEach(function (b) {
    b.addEventListener('click', function () { go(current - 1, { force: true }); });
  });

  function makeToggle(b) {
    b.addEventListener('click', function () {
      b.setAttribute('aria-pressed', b.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
      document.getElementById('hint1').textContent = '';
    });
  }
  root.querySelectorAll('.card, .chip:not(.add)').forEach(makeToggle);

  // "+ Add your own" keep-out
  var addBtn = document.getElementById('add-btn');
  var addRow = document.getElementById('addrow');
  var addInput = document.getElementById('add-input');
  addBtn.addEventListener('click', function () {
    addRow.hidden = !addRow.hidden;
    addBtn.setAttribute('aria-expanded', String(!addRow.hidden));
    if (!addRow.hidden) addInput.focus();
  });
  function addCustom() {
    var v = addInput.value.replace(/,/g, ' ').trim();
    if (!v) { addInput.focus(); return; }
    v = v.charAt(0).toUpperCase() + v.slice(1);
    var chip = document.createElement('button');
    chip.type = 'button';
    chip.className = 'chip custom';
    chip.setAttribute('aria-pressed', 'true');
    chip.textContent = v;
    makeToggle(chip);
    addBtn.parentNode.insertBefore(chip, addBtn);
    addInput.value = '';
    addInput.focus();
  }
  document.getElementById('add-go').addEventListener('click', addCustom);
  addInput.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') { e.preventDefault(); addCustom(); }
  });

  function picks() {
    return {
      cats: pressed('#cats .card').map(function (b) { return b.dataset.val; }),
      avoid: pressed('#avoid .chip:not(.add)').map(function (b) { return b.textContent; }),
      about: document.getElementById('about').value
    };
  }

  function buildSummary() {
    var p = picks();
    document.getElementById('sum-title').textContent = p.cats.join(', ');
    var ul = document.getElementById('sum-list');
    ul.textContent = '';
    p.cats.forEach(function (c) {
      var li = document.createElement('li');
      li.textContent = examples[c];
      ul.appendChild(li);
    });
    var tags = document.getElementById('sum-free');
    tags.textContent = '';
    var list = p.avoid.length ? p.avoid : ['Nothing extra. Our standard still applies.'];
    list.forEach(function (a) {
      var t = document.createElement('span');
      t.textContent = a;
      tags.appendChild(t);
    });
  }

  // Shopify tags: commas split tags, so strip them from values.
  function clean(s, max) {
    return String(s).replace(/\s*[,\n\r]+\s*/g, '; ').replace(/\s+/g, ' ').trim().slice(0, max || 60);
  }

  var form = document.getElementById('VettaJoin');
  var email = document.getElementById('email');
  var err = document.getElementById('err');
  email.addEventListener('input', function () { err.textContent = ''; });
  form.addEventListener('submit', function (e) {
    var addr = email.value.trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(addr)) {
      e.preventDefault();
      err.textContent = 'Enter a valid email, like you@email.com.';
      email.focus();
      return;
    }
    var p = picks();
    var tags = ['waitlist'];
    p.cats.forEach(function (c) { tags.push('pick: ' + clean(c)); });
    p.avoid.forEach(function (a) { tags.push('avoid: ' + clean(a)); });
    if (p.about.trim()) tags.push('note: ' + clean(p.about, 220));
    document.getElementById('vtags').value = tags.join(', ');
    store({ name: document.getElementById('fname').value.trim(), email: addr, picks: p });
    // Let the form submit normally so Shopify saves the customer.
  });

  function prefill() {}

  // Founding button: add the box on the monthly plan, apply both first-box codes, go to checkout.
  var found = document.getElementById('VettaFounding');
  if (found && window.fetch && window.FormData) {
    found.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = found.querySelector('button[type="submit"]');
      if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.disabled = true; }
      var fd = new FormData(found);
      var item = { id: Number(fd.get('id')), quantity: 1 };
      if (fd.get('selling_plan')) item.selling_plan = Number(fd.get('selling_plan'));
      var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      var codes = found.getAttribute('data-codes') || '';
      function post(url, body) {
        return fetch(base + url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(body || {})
        }).then(function (r) { if (!r.ok) throw new Error(url); return r.json(); });
      }
      var dest = base + 'checkout' + (codes ? '?discount=' + encodeURIComponent(codes) : '');
      post('cart/clear.js')
        .then(function () { return post('cart/add.js', { items: [item] }); })
        .then(function () {
          // Apply both codes to the cart too; if this step fails, the checkout link still carries them.
          return codes ? post('cart/update.js', { discount: codes }).catch(function () {}) : null;
        })
        .then(function () { window.location.href = dest; })
        .catch(function () { found.submit(); });
    });
  }

  document.getElementById('restart').addEventListener('click', function () {
    root.querySelectorAll('.card, .chip:not(.add)').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
    root.querySelectorAll('.chip.custom').forEach(function (c) { c.remove(); });
    document.getElementById('about').value = '';
    addRow.hidden = true;
    addBtn.setAttribute('aria-expanded', 'false');
    form.reset();
    go(0, { force: true });
  });

  // After Shopify reloads the page from the form post, show the right step.
  var state = document.getElementById('vetta-form-state');
  var posted = (state && state.dataset.state === 'posted') || /[?&]customer_posted=true/.test(window.location.search);
  if (posted) {
    var saved = recall();
    document.getElementById('done-name').textContent = saved.name ? ', ' + saved.name : '';
    prefill();
    go(5, { force: true });
  } else if (state && state.dataset.state === 'error') {
    var msg = state.dataset.error || '';
    var back = recall();
    if (back.picks) {
      root.querySelectorAll('#cats .card').forEach(function (b) {
        if (back.picks.cats.indexOf(b.dataset.val) > -1) b.setAttribute('aria-pressed', 'true');
      });
      var known = [];
      root.querySelectorAll('#avoid .chip:not(.add)').forEach(function (b) {
        known.push(b.textContent);
        if (back.picks.avoid.indexOf(b.textContent) > -1) b.setAttribute('aria-pressed', 'true');
      });
      back.picks.avoid.forEach(function (a) {
        if (known.indexOf(a) === -1) { addInput.value = a; addCustom(); }
      });
      addRow.hidden = true;
      document.getElementById('about').value = back.picks.about || '';
      if (back.name) document.getElementById('fname').value = back.name;
      if (back.email) email.value = back.email;
    }
    go(4, { force: true });
    err.textContent = /taken|already/i.test(msg)
      ? "You're already on the list with this email. Thanks for being here!"
      : (msg || 'Something went wrong. Please try again.');
  }
})();
